import {getQueryParam} from 'utils/imageUtils';

const PARAM_CONFIG = {
  autoNegate: {type: 'binary'},
  debopacity: {keepDecimal: true, type: 'number'},
  design: {transform: (val) => val.trim(), type: 'string'},
  digest: {type: 'string'},
  imdeboss: {type: 'boolean'},
  imengrave: {type: 'boolean'},
  ixbg: {type: 'string'},
  ixfm: {type: 'string'},
  ixh: {type: 'number'},
  ixq: {type: 'number'},
  ixw: {type: 'number'},
  noauto: {type: 'boolean'},
  opacity: {keepDecimal: true, type: 'number'},
  placeMax: {type: 'binary'},
  placeMaxCenter: {keepDecimal: true, type: 'number'},
  placeMaxPct: {keepDecimal: true, type: 'number'},
  placeUseProduct: {type: 'binary'},
  placeUseView: {type: 'string'}
};

/**
 * Extracts all editable parameters from a URL (no validation - let React Hook Form handle that)
 * @param {string} sourceUrl - The URL to parse parameters from
 * @returns {Object} Object containing parsed form updates
 */
export const extractEditableParams = (sourceUrl) => {
  const formUpdates = {};

  const colorMatch = sourceUrl.match(/\/colors\/(\d+)\//);
  if (colorMatch) {
    const [, colorId] = colorMatch;
    formUpdates.colorId = colorId;
  }

  Object.entries(PARAM_CONFIG).forEach(([param, config]) => {
    const value = getQueryParam(sourceUrl, param);
    if (value === null) return;

    switch (config.type) {
      case 'string': {
        if (config.decode) {
          formUpdates[param] = decodeURIComponent(value);
        } else if (config.transform) {
          formUpdates[param] = config.transform(value);
        } else {
          formUpdates[param] = value;
        }
        break;
      }
      case 'binary': {
        formUpdates[param] = Number(value) === 1 ? 1 : 0;
        break;
      }
      case 'boolean': {
        formUpdates[param] = Boolean(Number(value));
        break;
      }
      case 'number': {
        const parsed = Number(value);
        if (Number.isFinite(parsed)) {
          formUpdates[param] = config.keepDecimal ? parsed : Math.trunc(parsed);
        }
        break;
      }
      default: {
        break;
      }
    }
  });

  return formUpdates;
};

/**
 * Builds MMS parameters from form values
 * @param {Object} values - Form values
 * @returns {Object} Parameters object for URL construction
 */
export const buildEditableParams = (values) => {
  const params = {};

  // Process all configured parameters
  Object.entries(PARAM_CONFIG).forEach(([param, config]) => {
    const value = values[param];
    if (value === null || value === undefined || value === '') return;

    switch (config.type) {
      case 'string': {
        const stringValue =
          typeof value === 'string' ? value.trim() : String(value);
        if (stringValue) {
          params[param] = config.encode
            ? config.encode(stringValue)
            : stringValue;
        }
        break;
      }
      case 'binary': {
        if (value === 1) params[param] = 1;
        break;
      }
      case 'boolean': {
        if (value) params[param] = 1;
        break;
      }
      case 'number': {
        if (Number.isFinite(Number(value))) {
          params[param] = Number(value);
        }
        break;
      }
      default: {
        break;
      }
    }
  });

  return params;
};
